import { CTA_VERTICAL } from '../../helpers/constants/analyticsConstants';

import { trackSmartMetric } from './trackSmartMetric';

const getCTASmartMetricName = (vertical: string) => {
  const verticalType =
    vertical === CTA_VERTICAL.FLIGHTS
      ? CTA_VERTICAL.FLIGHTS
      : CTA_VERTICAL.HOTELS;

  return `month_view_flights_tab_${verticalType}_cta_clicked`;
};

const trackCTASmartMetric = (vertical: string) =>
  trackSmartMetric(getCTASmartMetricName(vertical));

export { trackCTASmartMetric };
